import React, {
  useState,
  useRef,
  useContext
}                             from 'react';
import { useTranslation}      from 'react-i18next';
import { toast }              from 'react-toastify';
import CardContext            from '../context';
import card_membership        from '@material-ui/icons/CardMembership';
import List                   from '~/containers/List';
import Request                from '~/providers/Request';
import ModalDelete            from '~/components/ModalDelete';
import {
  createCards,
  showCards,
  editCards
}                             from '~/config/routes';
import moment                 from 'moment';
import { AbilityContext }     from '~/contexts/Can';

function CardList() {
  const { t } = useTranslation();
  const [ modalInfo, setModalInfo ] = useState({ show: false });
  const listEl = useRef(null);
  const { delRecord } = useContext(CardContext);
  const ability = useContext(AbilityContext);

  function handleDeletionModal(id, name){
    setModalInfo({ show: true, id, name });
  }

  const trAttr = (attr) => t(`cards.attributes.${attr}`);

  async function handleDelete(){
    try {
      await Request.del(`/admin/promo_cards/${modalInfo.id}`);
      delRecord( modalInfo.id );
      listEl.current.onQueryChange();
      toast.success(t('delete-toast-success'));
    } catch(e) {
      toast.error(t('delete-toast-fail'));
    } finally {
      setModalInfo({ show: false });
    }
  }

  const actions = [
    'search',
    'filter',
  ];

  if(ability.can('new', 'Cards')) {
    actions.push('new');
  }
  if(ability.can('edit', 'Cards')) {
    actions.push('edit');
  }
  if(ability.can('delete', 'Cards')) {
    actions.push('del');
  }
  if(ability.can('show', 'Cards')) {
    actions.push('show');
  }

  return (
    <div>
      <List
        deleteAction={handleDeletionModal}
        routeToNew={createCards}
        routeToEdit={editCards}
        routeToShow={showCards}
        listEl={listEl}
        path={'/admin/promo_cards'}
        actions={actions}
        paperProps={{
          Icon:card_membership,
          iconColor:'green',
          title:t('cards.defPlural'),
        }}
        columns={[
          { title: trAttr('is_active'), field: 'is_active', type: 'boolean' },
          { title: trAttr('type'), field: 'type', type: 'string', render: (rowData) => <label>{t(`card_type.${rowData.type}`)}</label>}, // eslint-disable-line
          { title: trAttr('name'), field: 'name', type: 'string' },
          { title: trAttr('description'), field: 'description', type: 'string' },
          { title: trAttr('updated_at'), field: 'updated_at', type: 'datetime' }
        ]}
        context={CardContext}
        recordMap={
          record => ({
            ...record,
            created_at: record.created_at ? moment(record.created_at).format('DD/MM/YYYY HH:mm') : null,
            updated_at: record.updated_at ? moment(record.updated_at).format('DD/MM/YYYY HH:mm') : null,
          })
        }
      />
      <ModalDelete
        modal={modalInfo.show}
        onClose={() => setModalInfo({ show: false })}
        name={modalInfo.name}
        id={modalInfo.id}
        deleteAction={handleDelete}
      />
    </div>
  );
}

export default React.memo(CardList);
